import React from 'react'

const AdmissionProcess = () => {
  return (
    <div>
    <h1>admission into levelOne</h1>
    <hr />
    <p>This page will help you to understand the process of applying for the neoG Camp levelOne. Everything you need to know is here.</p>

    <ol>
        <li>who can apply for levelOne
            <ul>
                <li>newcomer: who just got to know about the neoG Camp; or who were unable to start doing assignments due to their examinations or other reasons; or</li>
                <li>beginner: who has never done programming in their life before; or</li>
                <li>intermediate: who knows basic programming. They don't need to watch the videos, but just complete the assignments; or</li>
                <li>keen learner: someone who just want to learn more intermediate and advanced level of programming; or</li>
                <li>job seekers or job-shifters: anyone who wants a job or who wants to shift from their current job; or</li>
                <li>non-job seekers: anyone who doesn't need a job and just wants to learn to program;</li>
                <p>But if you can complete the mark9 portfolio and submit it on the admission platform of neoG Camp, you can apply for levelOne.</p>
            </ul>
        </li>
    </ol>

    <h1>The Admission Process</h1>
    <hr />

    <ol>
        <li>Stage 1: Work on your levelZero portfolio
            <ul>
                <li>Start learning your levelZero here</li>
                <li>beginner: who has never done programming in their life before; or</li>
                <li>Complete your portfolio. Do the levelZero assignments. Please go through the mark15 checklist and complete minimum till mark9 projects.</li>
            </ul>
        </li>
        <li>Stage 2: Apply for levelOne on the admission platform and fill out the admission form
            <ul>
                <li>Sign up/log in on the admission portal using your GitHub account</li>
                <li>Fill and submit all the necessary details in the Admission Form.</li>
            </ul>
        </li>
        <li>Stage 3: Submit your portfolio for review
            <ul>
                <li>After filling up the admission form, submit your portfolio for review.</li>
                <li>Please ensure that your portfolio is complete and self-assess your portfolio before submitting it. Use the mark15 checklist.</li>
            </ul>
        </li>
    </ol>
</div>
  )
}

export default AdmissionProcess